/**
 * Created by - Ashlekh on 13-02-2025
 * Reason - To add R&D page
 */

import React, { useEffect, useState, useContext } from "react";

import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import Style from "./ResearchAndDevelopment.module.css";
import parse from "html-react-parser";
import { baseURL } from "../../Api/config";
import { researchAndDevelopment } from "../../Api/services";

const ResearchAndDevelopment = () => {
  const [researchAndDevelopmentDetails, setResearchAndDevelopmentDetails] =
    useState(null);
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);

  const fetchData = async () => {
    try {
      const response = await researchAndDevelopment();
      setResearchAndDevelopmentDetails(response.researchAndDevelopment_details);
    } catch (error) {
      console.error("Error fetching Research and Development details:", error);
    } finally {
      setShowContent(true);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "R & D", path: "/research-and-development" },
    ]);
    fetchData();
  }, []);

  return (
    <>
      {showContent ? (
        <>
          <div className={Style.mainContainer}>
            {researchAndDevelopmentDetails?.banner_video_file ? (
              /\.(mp4|mkv|webm|avi|mov|flv|wmv)$/i.test(
                researchAndDevelopmentDetails.banner_video_file
              ) ? (
                <video autoPlay muted loop className={Style.banner_video}>
                  <source
                    src={`${baseURL}${researchAndDevelopmentDetails.banner_video_file}`}
                    type={`video/${researchAndDevelopmentDetails.banner_video_file
                      .split(".")
                      .pop()}`}
                  />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={`${baseURL}${researchAndDevelopmentDetails.banner_video_file}`}
                  alt="Banner"
                  className={Style.banner_image}
                />
              )
            ) : null}
            <NavigationPath navigationPathArray={navigationPath} />
            <div className={Style.subContainer}>
              {researchAndDevelopmentDetails?.title_and_description ||
              researchAndDevelopmentDetails?.title_and_description?.trim()
                ?.length > 0 ||
              researchAndDevelopmentDetails?.page_content ||
              researchAndDevelopmentDetails?.page_content?.trim()?.length >
                0 ? (
                <div className={Style.pageTitle}>
                  <div>
                    <div className={Style.title}>
                      <span className={Style.firstThree}>Res</span>
                      <span className={Style.gradientText}>
                        earch and Development
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={Style.noDetails}>
                  <p className={Style.noDetailText}>No details available</p>
                </div>
              )}
              {researchAndDevelopmentDetails?.title_and_description ? (
                <div className={Style.titleAndDescription}>
                  {parse(researchAndDevelopmentDetails.title_and_description)}
                </div>
              ) : null}

              {/* {researchAndDevelopmentDetails?.page_content ? (
                <div className={Style.pageContent}>
                  {parse(researchAndDevelopmentDetails.page_content)}
                </div>
              ) : null} */}
            </div>
          </div>
        </>
      ) : (
        <div className={Style.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" />
        </div>
      )}
    </>
  );
};

export default ResearchAndDevelopment;
